import {
  Component,
  ElementRef,
  ViewChild,
  OnInit,
} from "@angular/core";
import { GlobalApp } from "../../../tools/global";
import { Router, ActivatedRoute } from "@angular/router";
import { PowerBIService } from "../../../api/services/power-bi.service";
import * as pbi from "powerbi-client";
import {InteractivesService} from "../../../api/services/interactives.service";
import {SubInteractReportExports} from "../../../api/models/sub-interact-report-exports";

@Component({
  selector: "powerbi-report-export",
  templateUrl: "./powerbi-report-export.component.html",
})
export class PowerBiReportExport implements OnInit {
  reportInteractiveId: string = null;
  reportExportId: string = null;
  reportExportPage: string = null;

  @ViewChild("pbiContainer") pbiContainer: ElementRef;

  private powerBiClientService: pbi.service.Service;
  private embeddedReport: pbi.Report = null;
  private currentConfig: pbi.IEmbedConfiguration = null;

  private firstLoad = true;
  private awaitingGotoPage = false;
  private awaitingApplyFilter = false;
  private completeCount = 0;

  public render_complete: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private app: GlobalApp,
    private router: Router,
    private powerbiService: PowerBIService,
    private interactiveService: InteractivesService,
  ) {
    this.powerBiClientService = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.reportInteractiveId = params.get("reportInteractiveId");
      this.reportExportId = params.get("reportExportId");
      this.reportExportPage = params.get("reportPage");

      this.interactiveService.interactivesGetReportExport({interactiveId: parseInt(this.reportInteractiveId), reportExportId: parseInt(this.reportExportId)}).subscribe((dbReportExport) => {

        this.powerbiService.powerBIGetPowerBISettingsForInteractive(parseInt(this.reportInteractiveId)).subscribe((powerBiSettingsResults) => {

          this.currentConfig = {
            type: "report",
            id: powerBiSettingsResults.reportId,
            embedUrl: powerBiSettingsResults.embedUrl,
            accessToken: powerBiSettingsResults.accessToken,
            settings: {
              visualRenderedEvents: true,
              navContentPaneEnabled: false,
              filterPaneEnabled: false,
              bars: {
                actionBar: {
                  visible: false,
                },
              },
            },
          };

          this.embeddedReport = this.powerBiClientService.embed(
            this.pbiContainer.nativeElement,
            this.currentConfig
          ) as pbi.Report;

          this.embeddedReport.on('visualRendered', (_) => {
            if (this.awaitingGotoPage) {
              const thisCompleteCount = this.completeCount + 1;
              this.completeCount++;
              this.checkGotoPage(thisCompleteCount, dbReportExport);
            } else if (this.awaitingApplyFilter) {
              const thisCompleteCount = this.completeCount + 1;
              this.completeCount++;
              this.checkApplyFilter(thisCompleteCount, dbReportExport);
            }
          })

          this.embeddedReport.on("rendered", (_) => {
            if (this.firstLoad) {
              this.injectBookmarks(dbReportExport.reportState).then(() => {
                this.awaitingApplyFilter = true;
              })
              this.firstLoad = false;
            }
          });
        });
      });
    });
  }

  checkGotoPage(thisCompleteCount: number, dbReportExport: SubInteractReportExports) {
    setTimeout(() => {
      if (this.completeCount === thisCompleteCount) {
        this.awaitingGotoPage = false;
        this.renderComplete();
      }
    }, 30000)
  }

  checkApplyFilter(thisCompleteCount: number, dbReportExport: SubInteractReportExports) {
    setTimeout(() => {
      if (this.completeCount === thisCompleteCount) {
        this.awaitingApplyFilter = false;
        this.completeCount = 0;
        this.injectBookmarks(dbReportExport.reportState);

        setTimeout(() => {
          this.awaitingGotoPage = true;
          this.embeddedReport.setPage(this.reportExportPage);
        }, 30000);
      }
    }, 30000);
  }

  renderComplete(): void {
    console.log('Render Complete');

    this.interactiveService.interactivesSetReportExportPageComplete({interactiveId: parseInt(this.reportInteractiveId), reportExportId: parseInt(this.reportExportId), completedPage: this.reportExportPage}).subscribe((result) => {
      this.render_complete = true;
    })
  }

  injectBookmarks(bookmarkJSON: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      console.log("Applying Filter...");
      this.embeddedReport.bookmarksManager.applyState(
        JSON.parse(bookmarkJSON).state
      ).then(() => {
        console.log("Filters Applied");
        resolve();
      });
    });
  }
}
